import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";

import AddServiceModal from "./components/AddServiceModal";
import QuotationControls from "./components/QuotationControls";
import QuotationHeader from "./components/QuotationHeader";
import SelectedServicesPanel from "./components/SelectedServicesPanel";
import ServiceCatalogPanel from "./components/ServiceCatalogPanel";
import { useQuotationExport } from "./hooks/useQuotationExport";
import { useSelectedServices } from "./hooks/useSelectedServices";
import { useServiceCatalog } from "./hooks/useServiceCatalog";
import Modal from "../components/Modal";
import MobilePatternHeader from "../components/MobilePatternHeader";

const QuotationPage = () => {
  const { token_client } = useContext(AuthContext);
  const navigate = useNavigate();

  const catalog = useServiceCatalog(token_client);
  const selected = useSelectedServices();

  const [previewUrl, setPreviewUrl] = useState(null);

  const exporter = useQuotationExport({
    token_client,
    customPricing: selected.customPricing,
    specialist: selected.specialist,
    email: selected.email,
    phone: selected.phone,
    selectedServices: selected.selectedServices,
    visibleTiers: selected.visibleTiers,
    calculateTotal: selected.calculateTotal,
    calculateTotalVat: selected.calculateTotalVat,
    calculateFinalTotal: selected.calculateFinalTotal,
  });

  const handlePreview = async () => {
    const url = await exporter.previewQuotation();
    if (url) {
      setPreviewUrl(url);
    }
  };

  const handleClosePreview = () => {
    if (previewUrl && previewUrl.startsWith("blob:")) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl(null);
  };

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden bg-gray-50 min-[1201px]:h-auto min-[1201px]:min-h-full min-[1201px]:overflow-visible min-[1201px]:gap-6">
      <MobilePatternHeader
        title="Báo phí"
        onBack={() => navigate(-1)}
        className="lg:hidden"
      />

      <div className="min-h-0 flex-1 overflow-y-auto min-[1201px]:flex min-[1201px]:flex-col min-[1201px]:gap-6 min-[1201px]:overflow-visible">
        <div className="flex shrink-0 flex-col gap-4 px-4 min-[1201px]:gap-6 min-[1201px]:px-0 min-[1201px]:pb-0">
          <QuotationHeader />
          <QuotationControls
            specialist={selected.specialist}
            setSpecialist={selected.setSpecialist}
            email={selected.email}
            setEmail={selected.setEmail}
            phone={selected.phone}
            setPhone={selected.setPhone}
            customPricing={selected.customPricing}
            setCustomPricing={selected.setCustomPricing}
          />
        </div>

        <div className="px-4 py-4 pb-[calc(104px+env(safe-area-inset-bottom))] md:p-4 min-[1201px]:p-0">
          <div className="flex flex-col gap-6 bg-transparent p-0">
            <div className="w-full shrink-0">
              <ServiceCatalogPanel
                categories={catalog.categories}
                selectedCategory={catalog.selectedCategory}
                categoriesLoading={catalog.categoriesLoading}
                categoryError={catalog.categoryError}
                services={catalog.services}
                loading={catalog.loading}
                loadingMore={catalog.loadingMore}
                hasMore={catalog.hasMore}
                servicesError={catalog.servicesError}
                observerTarget={catalog.observerTarget}
                onOpenCreate={() => catalog.setOpenAddModal(true)}
                onCategoryChange={catalog.onCategoryChange}
                onAddService={selected.addService}
                onRemoveService={selected.removeService}
                selectedServices={selected.selectedServices}
                formatCurrency={selected.formatCurrency}
              />
            </div>

            <div className="h-[540px] w-full min-w-0 md:h-[620px] min-[1201px]:h-[760px]">
              <SelectedServicesPanel
                data={selected}
                exporting={exporter.exporting}
                previewing={exporter.previewing}
                onExport={exporter.exportQuotation}
                onPreview={handlePreview}
              />
            </div>
          </div>
        </div>
      </div>

      <AddServiceModal
        open={catalog.openAddModal}
        onClose={() => catalog.setOpenAddModal(false)}
        onCreated={(createdService) => {
          catalog.prependTempService(createdService);
          selected.addService(createdService);
          catalog.setOpenAddModal(false);
        }}
      />

      <Modal
        isOpen={!!previewUrl}
        onClose={handleClosePreview}
        title="Xem trước báo giá"
        maxWidth="1100px"
        maxHeight="calc(100vh - 24px)"
        dialogClassName="min-h-0"
        bodyClassName="bg-slate-100"
        showCancelButton={false}
        primaryButtonText="Đóng"
        primaryButtonOnClick={handleClosePreview}
      >
        <div className="min-h-full w-full p-3 sm:p-5">
          <div className="mx-auto flex w-full max-w-[900px] justify-center">
            <img
              src={previewUrl}
              alt="Xem trước báo giá"
              className="block h-auto w-full border border-slate-200 bg-white shadow-[0_18px_40px_rgba(15,23,42,0.12)]"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default QuotationPage;
